export const GOSeatCategoryType = Object.freeze({
    GLOBAL: 'global',
    MAIN_EVENT: 'mainEvent',
});
